import { key, notify } from '@databases/ping-registry';
import { getService } from '@databases/service-container';
import { createCellEditingEffect } from '@databases/value/cell-edit-effect';
import { TABLE_V2_LAYOUT_ID } from '@databases/view-layout-table-v2/id';

import {
  type SelectionEffectFeature,
  SelectionFeatureKeys,
} from '../../features/types.ts';

export function createCellEditingEffectFeature(): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.CELL_EDITING_EFFECT,
    type: 'effect',
    isEnabled: (ctx) =>
      ctx.layoutType !== TABLE_V2_LAYOUT_ID && ctx.permissions.canEditContent,
    factory: () =>
      createCellEditingEffect({
        selectionsApi: getService('SelectionsApi'),
        notifyCellEditing: (params: {
          entryId: string;
          fieldId: string;
          editing: boolean;
          context: 'table' | 'panel';
          initialKey?: string;
        }): void => {
          notify(
            key('cell', { entryId: params.entryId, fieldId: params.fieldId }),
            'editing',
            {
              active: params.editing,
              context: params.context,
              initialKey: params.initialKey,
            },
          );
        },
      }),
  };
}
